/**
 * 上传🆓压缩
 * @param {*} file 压缩文件
 * @param {*} limit 大小限制
 */
const compressionImg = (file, limit) => {
  if (file.size < limit) {
    return new Promise((resolve, reject) => {
      resolve(file)
    })
  } else {
    const compressionImage = new Promise((resolve, reject) => {
      const fileName = file.name
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const img = new Image()
        img.src = reader.result
        img.onload = () => {
          const elem = document.createElement('canvas')
          const originWidth = img.width
          const originHeight = img.height
          const maxWidth = 1280
          const maxHeight = 1280
          let targetWidth = originWidth
          let targetHeight = originHeight
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              targetWidth = maxWidth
              targetHeight = Math.round(maxWidth * (originHeight / originWidth))
            } else {
              targetHeight = maxHeight
              targetWidth = Math.round(maxHeight * (originWidth / originHeight))
            }
          }
          const ctx = elem.getContext('2d')
          elem.width = targetWidth
          elem.height = targetHeight
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight)
          document.body.append(elem)
          // 兼容代码 IE
          if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
              value(callback, type, quality) {
                const dataURL = this.toDataURL(type, quality).split(',')[1]
                setTimeout(() => {
                  const binStr = atob(dataURL)
                  const len = binStr.length
                  const arr = new Uint8Array(len)
                  for (let i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i)
                  }
                  callback(new Blob([arr], { type: type || 'image/jpeg' }))
                })
              }
            })
          }
          ctx.canvas.toBlob(
            (blob) => {
              const cFile = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
              resolve(cFile)
            },
            'image/jpeg',
            0.8,
          )
          document.body.removeChild(elem)
        }
        reader.onerror = error => reject(error)
      }
    })
    return compressionImage
  }
}

export default compressionImg



// WEBPACK FOOTER //
// ./src/utils/compressionImg.js